var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyinline = function SvgCopyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.995,
    height: 9.002,
    x: 5.939,
    y: 5.935,
    stroke: "currentColor",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.434.935a1.5 1.5 0 0 0-1.5 1.5v7.001a1.5 1.5 0 0 0 1.5 1.5h1.499a.5.5 0 0 0 0-1h-1.5a.5.5 0 0 1-.5-.5V2.435a.5.5 0 0 1 .5-.5h6.995a.5.5 0 0 1 .5.5v1.5a.5.5 0 1 0 1 0v-1.5a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgCopyinline;